import React, { useState } from 'react';
import { Row, Modal, Button } from 'react-materialize';
import ButtonUI from '../../../../../components/UI/ButtonUI';
import { translate, showMessageToastCustom } from '../../../../../utils/util';
import Select from '../../../../../components/UI/Select';
import { validateInputsRequired, onValueChange } from '../../../../../utils/handleChangeHooks';


const ConfirmModalStart = (props) => {
    const [route, setRoute] = useState({});
    const onChange = (event) => {
        onValueChange(event, route, setRoute);
        props.filter.routeId = route.id;
        props.setFilter(props.filter);
    };

    return (
        <Modal
            open={props.open}
            id={props.id ? props.id : 'Modal-UI'}
            options={{
                dismissible: props.dismissible
            }}
            actions={
                <Row className="center" style={{ height: "60%" }}>
                    <Button onClick={() => {
                        props.history.go(-1);
                    }} className="col s6 btn waves-effect waves-light btn-flat" modal="close" disabled={props.disabledCancel}>
                        {props.btnCancel ? props.btnCancel : translate('cancel', 'general')}
                    </Button>
                    <ButtonUI onClick={() => {
                        if (validateInputsRequired()) {
                            props.onConfirm();
                        }
                        else {
                            showMessageToastCustom(translate('general:warning'),
                                translate('validations:required'),
                                3000, 'mdi mdi-alert-circle-outline red-text');
                        }

                    }}
                        text={props.btnConfirm ? props.btnConfirm : translate('confirm', 'general')}
                    />
                </Row>
            }
        >
            <Row className="center">
                <div className="sixth-text-color center">
                    <span className="col s12">
                        <i className="material-icons large">info_outline</i>
                    </span>
                    <span className="title col s12">{translate('validations:attention')}</span>
                    {/* <span className="col s12" >{translate('expedition:picking.confirm-rePicking')}</span> */}
                    <div className="input-field no-padding col s12" >
                        <Select
                            required
                            id="id"
                            name="id"
                            label={translate('route', 'route-picking')}
                            change={onChange}
                            defaultValue={route?.id}
                            placeHolder={translate('general:choose-one-option')}
                            data={props.routes ? props.routes.map((i) => { return { id: i.id, text: i.code }; }) : []}
                        />
                    </div>
                </div>
            </Row>
        </Modal>
    );
};

export default ConfirmModalStart;